export enum LoanOfferStatus {
  Pending,
  Accepted,
  Rejected,
}
